module.exports = __webpack_public_path__ + "media/images/flags/zm-79a41234f024ca5ab0a9ea130ab83b7b.svg";